import { useTranslation } from 'react-i18next';
import { alpha, styled } from '@mui/material/styles';
import FormHelperText from '@mui/material/FormHelperText';
import ControllerContainer from '../Components/ControllerContainer';

export default function withDesign(Input) {
  const DelintenetDesignInput = styled(Input)(({ theme }) => styles.styled(theme));

  return function ({ label, helperText, error, customLabel, ...props }) {
    const { name } = props;
    const { t } = useTranslation();

    let placeholder = undefined;
    if ('placeholder' in props) placeholder = t(props.placeholder);

    if ('shouldRender' in props && !props.shouldRender(props)) return;

    if (customLabel) {
      return <Input label={t(label)} {...props} />;
    }

    const id = `form-input-${label || label !== '' ? label : name}`.split(' ').join('-');

    return (
      <ControllerContainer label={t(label)} error={error} id={id}>
        <DelintenetDesignInput {...props} placeholder={placeholder} id={id} sx={styles.input(error)} />
        {error ? <FormHelperText sx={{ color: ({ palette }) => palette.error.main }}>{t(helperText)}</FormHelperText> : null}
      </ControllerContainer>
    );
  };
}

const styles = {
  input: error => ({
    '& fieldset': {
      borderRadius: '12px',
      borderColor: theme => (error ? theme.palette.error.main : theme.palette.divider),
    },
    '& .MuiInputBase-input::placeholder': {
      fontSize: '0.8rem',
    },
    '& .MuiInputBase-input:hover fieldset': {
      borderColor: theme => (error ? theme.palette.error.main : theme.palette.primary.main),
    },
    '& .MuiInputBase-input:focus fieldset': {
      borderColor: theme => (error ? theme.palette.error.main : theme.palette.primary.main),
      boxShadow: theme => `${alpha(error ? theme.palette.error.main : theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
    },
  }),
  styled: theme => ({
    'label + &': {
      marginTop: theme.spacing(2.5),
    },
    '& .MuiInputBase-input': {
      fontSize: 16,
      position: 'relative',
      padding: '10px 12px',
      transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    },
  }),
};
